import { takeEvery } from 'redux-saga/effects';
import { POST_MARK_AS_READ_NOTIFICATIONS } from './notifications.action';
import { postMarkAsReadNotificationSaga } from './notifications.saga';

export const NotificationsSaga = [
  takeEvery(POST_MARK_AS_READ_NOTIFICATIONS, postMarkAsReadNotificationSaga),
];
